module.exports = __webpack_public_path__ + "80981339dfbbacde0140ef1ffc710849.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-rabbit-cheers.png
// module id = 2077
// module chunks = 4